
/* AUTHENTICATION */
export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_FAILURE = 'AUTH_LOGIN_FAILURE';

/* REGISTER */
export const AUTH_REGISTER = 'AUTH_REGISTER';
export const AUTH_REGISTER_SUCCESS = 'AUTH_REGISTER_SUCCESS';
export const AUTH_REGISTER_FAILURE = 'AUTH_REGISTER_FAILURE';

/* LOGOUT */
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const AUTH_GET_STATUS = 'AUTH_GET_STATUS';
export const AUTH_GET_STATUS_SUCCESS = 'AUTH_GET_STATUS_SUCCESS';
export const AUTH_GET_STATUS_FAILURE = 'AUTH_GET_STATUS_FAILURE';

/* NOTICE */
export const NOTICE_OFF = 'NOTICE_OFF';